import {
  ActionIcon,
  AppShell,
  Burger,
  Flex,
  Group,
  Title,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconLogout } from "@tabler/icons-react";
import { useQueryClient } from "@tanstack/react-query";
import { NavBar } from "components/home";
import LanguageSwitcher from "components/LanguageSwitcher";
import { useQueryCurrentUser } from "hooks/users";
import { Outlet } from "react-router-dom";
import { supabaseClient } from "supabase";

export const Home = () => {
  // const { signOut } = useAuth();
  const [mobileOpened, { toggle: toggleMobile }] = useDisclosure();
  const [desktopOpened, { toggle: toggleDesktop }] = useDisclosure(true);
  const queryClient = useQueryClient();
  const { user, isLoading } = useQueryCurrentUser();

  const signOut = () => {
    // Clear the current user query from React Query cache
    queryClient.removeQueries({ queryKey: ["currentUser"] });
    // Clear all queries from the cache
    queryClient.clear();
    supabaseClient.auth.signOut();
  };

  if (isLoading) {
    return null;
  }

  return (
    <AppShell
      header={{ height: 50 }}
      navbar={{
        width: 300,
        breakpoint: "sm",
        collapsed: { mobile: !mobileOpened, desktop: !desktopOpened },
      }}
      padding="md"
    >
      <AppShell.Header>
        <Flex
          align="center"
          justify="space-between"
          h="100%"
          px="md"
          bg="#86AD91"
        >
          <Group h="100%">
            {!user.organizer_id && (
              <div style={{ zIndex: 10 }}>
                <Burger
                  opened={mobileOpened}
                  onClick={toggleMobile}
                  hiddenFrom="sm"
                  size="sm"
                />
                <Burger
                  opened={desktopOpened}
                  onClick={toggleDesktop}
                  visibleFrom="sm"
                  size="sm"
                />
              </div>
            )}
            <Title size="h3">ADMIN</Title>
          </Group>
          <Group h="100%" gap="xl" style={{ zIndex: 10 }}>
            <LanguageSwitcher />
            <ActionIcon variant="transparent" onClick={signOut}>
              <IconLogout size={24} color="black" onClick={() => {}} />
            </ActionIcon>
          </Group>
        </Flex>
        <div
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            top: 0,
            left: 0,
            right: 0,
            zIndex: 0,
          }}
        >
          <Flex justify="center">
            <img
              src="/images/logo.png"
              alt="Admin Logo"
              style={{
                height: "60px",
                borderRadius: 10,
              }}
            />
          </Flex>
        </div>
      </AppShell.Header>
      <AppShell.Navbar p="md" w={200}>
        <NavBar active={"s"} />
      </AppShell.Navbar>
      <AppShell.Main m={0} pl={220}>
        <Outlet />
      </AppShell.Main>
    </AppShell>
  );
};
